import { createSelector } from 'reselect';

export const selectFavorites = state => state.onboardingFavorites;
export const selectFavoritesConfig = createSelector(selectFavorites, favorites => favorites.config);
export const selectFavoritesIsLoading = createSelector(selectFavorites, favorites => favorites.isLoading);
export const selectFavoritesIsLoaded = createSelector(selectFavorites, favorites => favorites.isLoaded);
export const selectFavoritesMerchants = createSelector(selectFavorites, favorites => favorites.merchants);
export const selectFavoriteOnlineMerchants = createSelector(selectFavoritesMerchants, (merchants) => (
  merchants.filter(({ type }) => type === 'online')
));
